import React from 'react'
import useOpenNewTab from '../../hooks/useOpenNewTab'
import tripLogo from '../../images/tripAdvisorLogo.png'

function SocialMedia() {
    const {openTab} = useOpenNewTab()
    
    return (
        <>
            <h2>
                Share your success
            </h2>
            <div className="social_btns">
                <button 
                    className="landing_btn"
                    onClick={() => openTab('FACEBOOK')}
                >
                    <i className="fab fa-facebook-f"></i>
                </button>
                <button 
                    className="landing_btn"
                    onClick={() => openTab('TWITTER')}
                >
                    <i className="fab fa-twitter"></i>
                </button>
                <button 
                    className="landing_btn"
                    onClick={() => openTab('INSTAGRAM')}
                >
                    <i className="fab fa-instagram"></i>
                </button>
                <button 
                    className="landing_btn"
                    onClick={() => openTab('TRIPADVISOR')}
                >
                    <img src={tripLogo} alt='trip-advisor logo' className="landing_btn_img" />
                </button>
            </div>
        </>
    )
}

export default SocialMedia